module.exports = __webpack_public_path__ + "static/media/notFound.2c205b34.svg";